import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

export interface Props extends SvgIconProps {}

const StopIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={28} height={28} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.0001 0.666504C11.363 0.666504 8.78514 1.44849 6.59248 2.91358C4.39983 4.37866 2.69086 6.46104 1.68169 8.89739C0.672525 11.3337 0.408481 14.0146 0.92295 16.601C1.43742 19.1875 2.7073 21.5632 4.572 23.4279C6.4367 25.2926 8.81247 26.5625 11.3989 27.077C13.9853 27.5914 16.6662 27.3274 19.1025 26.3182C21.5389 25.3091 23.6213 23.6001 25.0863 21.4074C26.5514 19.2148 27.3334 16.6369 27.3334 13.9998C27.3334 12.2489 26.9885 10.5151 26.3185 8.89739C25.6484 7.27972 24.6663 5.80986 23.4282 4.57175C22.1901 3.33363 20.7202 2.35151 19.1025 1.68144C17.4849 1.01138 15.751 0.666504 14.0001 0.666504ZM24.6668 13.9998C24.6697 16.3687 23.8761 18.6698 22.4134 20.5332L7.46675 5.5865C9.33015 4.12386 11.6312 3.33022 14.0001 3.33317C16.8291 3.33317 19.5422 4.45698 21.5426 6.45736C23.5429 8.45775 24.6668 11.1709 24.6668 13.9998ZM3.33342 13.9998C3.33048 11.631 4.12411 9.3299 5.58675 7.4665L20.5334 22.4132C18.67 23.8758 16.369 24.6694 14.0001 24.6665C11.1711 24.6665 8.458 23.5427 6.45761 21.5423C4.45723 19.5419 3.33342 16.8288 3.33342 13.9998Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default StopIcon;
